import Cookies from "js-cookie";

const getFacebookTrackingObject = () => {
    const fbc = Cookies.get("_fbc");
    const fbp = Cookies.get("_fbp");

    if (fbc === undefined && fbp === undefined) {
        return undefined;
    }

    return { fbc, fbp };
};

export default getFacebookTrackingObject;
